import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiVisa, BranchLocationLinkService, LocationContainerModel, LocationService, Pagination } from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'blg-select-location-drop-down',
  templateUrl: './select-location-drop-down.component.html',
  styleUrls: ['./select-location-drop-down.component.css']
})
export class SelectLocationDropDownComponent implements OnInit, OnDestroy {

  @Input() location: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() required: boolean;
  @Input() branchSelectedGuid: string;
  @Input() label = 'Location';

  @Output() locationChange = new EventEmitter<FormControl>();
  @Output() locationSelected = new EventEmitter<LocationContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<LocationContainerModel[]> = new ReplaySubject<LocationContainerModel[]>(1);
  locationList: LocationContainerModel[] = [];
  selectedLocation = new LocationContainerModel();
  locations: any = [];

  protected _onDestroy = new Subject<void>();

  constructor(private lctnService: LocationService,
    private branchLocationLinkService: BranchLocationLinkService,
  ) { }

  ngOnInit() {
    // set initial selection
    // if (this.location.value) {
    //   this.lctnService.getByGuid(this.location.value, this.apiVisa).pipe(
    //     takeUntil(this._onDestroy)
    //   ).subscribe( resolved => {
    //     this.locationList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_inv_mst_location.guid.toString());
    //   });
    // }
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LocationFiltering();
      });

    // load the initial location list
    this.getAllLocations();
    // this.serverSideFiltering.valueChanges.pipe(
    //     filter(searchText => searchText.length > 3),
    //     tap(() => this.serverSideSearching = true),
    //     debounceTime(300),
    //     distinctUntilChanged(),
    //     switchMap(searchText => this.LocationFiltering(searchText))
    //   ).subscribe( resolved => {
    //     this.serverSideSearching = false;
    //     if (this.selectedLocation) {
    //       this.filteredOptions$.next([...resolved, this.selectedLocation]);
    //       this.locationList = [...resolved, this.selectedLocation];
    //     } else {
    //       this.filteredOptions$.next(resolved);
    //       this.locationList = resolved;
    //     }
    //   }, error => {
    //     this.serverSideSearching = false;
    //     console.error(error);
    //   });
  }

  ngOnChanges() {
    if (this.branchSelectedGuid) {
      this.getAllLocations();
    }
  }

  getAllLocations() {
    //empty the prev list when selected branch changed
    this.locationList = [];
    this.locations = [];
    this.filteredOptions$.next(null);

    //if there is a selected branch
    if (this.branchSelectedGuid) {

      let locationGuidsList = [];
      let pagination = new Pagination();
      pagination.conditionalCriteria = [];
      pagination.conditionalCriteria.push
        ({ columnName: 'guid_branch', operator: '=', value: this.branchSelectedGuid });

      this.branchLocationLinkService.getByCriteria(pagination, this.apiVisa).subscribe(
        (response) => {

          if (response.data && response.data.length) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].bl_fi_mst_branch_location_link.guid_location !== null) {
                locationGuidsList.push(response.data[i].bl_fi_mst_branch_location_link.guid_location.toString());
              }
            }

            let paging = new Pagination();
            paging.conditionalCriteria = [];
            paging.conditionalCriteria.push
              ({ columnName: 'hdr_guids', operator: '=', value: locationGuidsList.toString() });

            this.lctnService.getByCriteria(paging, this.apiVisa).subscribe(lctns => {
              //empty the prev list when selected branch changed
              this.locationList = [];
              this.locations = [];
              this.filteredOptions$.next(null);

              lctns.data.forEach((data) => {
                this.locations.push(data);
                this.locationList.push(data);
              });

              // sorting
              const sorted = this.locations.sort((a, b) => (a.bl_inv_mst_location.code < b.bl_inv_mst_location.code ? -1 : 1));
              //fill the drop down
              this.filteredOptions$.next(this.locations.slice());
            })
          }
        })
    }

    //if no selected branch => get All Locations
    else {
      this.lctnService.get(this.apiVisa).subscribe((x: any) => {
        x.data.forEach((data) => {
          this.locations.push(data);
          this.locationList.push(data);
        });
        // sorting
        const sorted = this.locations.sort((a, b) => (a.bl_inv_mst_location.code < b.bl_inv_mst_location.code ? -1 : 1));
        //fill the drop down
        this.filteredOptions$.next(this.locations.slice());
      });
    }
  }

  LocationFiltering() {
    if (!this.locations) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.locations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the locations
    this.filteredOptions$.next(
      this.locations.filter((option) =>
        (option.bl_inv_mst_location.code ?
          option.bl_inv_mst_location.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.bl_inv_mst_location.name ?
          option.bl_inv_mst_location.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  // searchLocation(searchText: string) {
  //   const query = `
  //     SELECT hdr.guid as requiredGuid
  //     FROM bl_inv_mst_location AS hdr
  //     WHERE
  //     hdr.status != 'DELETED'
  //     AND (
  //     hdr.code ILIKE'%${searchText}%'
  //     OR hdr.name ILIKE '%${searchText}%'
  //     )
  //     GROUP BY hdr.guid
  //     ORDER BY hdr.name, hdr.guid
  //   `;
  //   return this.sqService.post({ 'subquery': query, 'table': 'bl_inv_mst_location' }, this.apiVisa).pipe(
  //     mergeMap( b => {
  //       const source: Observable<LocationContainerModel>[] = [];
  //       b.data.forEach( guid => source.push(this.lctnService.getByCriteria(new Pagination(null, null, [
  //           {columnName: 'hdr_guids', operator: '=', value: guid.toString()}
  //         ]), this.apiVisa).pipe(
  //           map(b_inner => b_inner.data[0])
  //         )
  //       ));
  //       return iif(() => b.data.length > 0,
  //       forkJoin(source).pipe(),
  //       of([])
  //       );
  //     })
  //   );
  // }

  onSelect(locationGuid: string) {
    if (locationGuid) {
      this.location.patchValue(locationGuid);
      this.selectedLocation = this.locationList.find(lctn => lctn.bl_inv_mst_location.guid === locationGuid);
      this.locationSelected.emit(this.selectedLocation);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
